import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TypeCoinComponent } from './type-coin.component';
import { FormsModule } from '@angular/forms';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';



@NgModule({
  declarations: [
    TypeCoinComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    PipesModule,
    MatRadioModule
  ], exports:[
    TypeCoinComponent
  ]
})
export class TypeCoinModule { }
